import { resolveHotDealPrice } from '../merchants/_utils/resolveHotDeal';

const MIN_DISCOUNT_RATE = 20;
const MAX_HOT_DEALS_PER_MERCHANT = 5;
const MIN_VISIBLE_HOT_DEALS = 3;

const hashSeed = (value: string) =>
  Array.from(value).reduce(
    (hash, character) =>
      Math.imul(hash ^ character.charCodeAt(0), 16_777_619) >>> 0,
    2_166_136_261,
  );

interface HomeHotDealSource {
  affiliateHotDealId: string;
  merchantCode: string;
  normalPrice?: number | null;
  discountPrice?: number | null;
  discountRate?: number | null;
}

//* 「랜덤 노출」은 시드 고정 셔플로 한다 — Math.random이면 서버 렌더와 하이드레이션 순서가 갈린다.
export const selectHomeHotDeals = <T extends HomeHotDealSource>(
  hotDeals: T[],
  seed: string,
): T[] => {
  const countByMerchant = new Map<string, number>();
  const selectedHotDeals = hotDeals
    .filter(
      (hotDeal) =>
        (resolveHotDealPrice(hotDeal).discountRate ?? 0) >= MIN_DISCOUNT_RATE,
    )
    .map((hotDeal) => ({
      hotDeal,
      rank: hashSeed(`${seed}:${hotDeal.affiliateHotDealId}`),
    }))
    .sort((a, b) => a.rank - b.rank)
    .map(({ hotDeal }) => hotDeal)
    .filter((hotDeal) => {
      const merchantCount = countByMerchant.get(hotDeal.merchantCode) ?? 0;

      countByMerchant.set(hotDeal.merchantCode, merchantCount + 1);

      return merchantCount < MAX_HOT_DEALS_PER_MERCHANT;
    });

  return selectedHotDeals.length >= MIN_VISIBLE_HOT_DEALS
    ? selectedHotDeals
    : [];
};
